/**
 * InvoiceLineItems Component
 */

import { generateLicenseUsageFromComponents, getLicenseString } from '../../../../redux/helpers/license';
import { getResponsiveTrackThumbnail } from '../../../../utils/track';

import * as React from 'react';
import * as BEM from 'react-bem-helper';

import Thumbnail from '../../../atoms/images/Thumbnail';
import Heading from '../../../atoms/text/Heading';
import { Span } from '../../../atoms/text/Label';
import { PriceTagOwnProps } from '../../../atoms/text/PriceTag';
import InvoicePriceTag from '../../../atoms/text/PriceTag/InvoicePriceTag';
import { TableHeader } from '../../../atoms/text/TableHeader';

interface IOwnProps {
  order: GQL.IOrder;
}

const classes = new BEM('invoice__line-items');
const itemClasses = new BEM('invoice__line-item');

export default class InvoiceLineItems extends React.Component<IOwnProps, any> {
  renderLicenseLineItem = (lineItem: GQL.ILicenseLineItem) => {
    const track = lineItem.track!;
    const image = getResponsiveTrackThumbnail(track);
    const usages = lineItem.license!.usages!.map(({ air_date, components }) =>
      generateLicenseUsageFromComponents(components!, undefined, air_date));
    const licenseString = getLicenseString(usages);

    return (
      <tr key={lineItem.id} {...itemClasses('', 'license') }>
        <td>
          <div {...itemClasses('description')}>
            <Thumbnail responsiveAssets={image} size="xsmall" {...itemClasses('image') } />
            <div {...itemClasses('info') }>
              <Heading is="h5" text={track.title!} {...itemClasses('info__title') } />
              <Span
                text={track.artist!.name!}
                size="small"
                textColor="bw7"
                {...itemClasses('info__subtitle') }
              />
            </div>
          </div>
        </td>
        <td>
          <Span variant="description" size="large" {...itemClasses('terms') }>{licenseString}</Span>
        </td>
        <td>{this.renderAmount(lineItem)}</td>
      </tr>
    );
  }

  renderGeneralLineItem = (lineItem: GQL.IGeneralLineItem) => {
    return (
      <tr key={lineItem.id} {...itemClasses('', 'general') }>
        <td>
          <Span variant="description" size="large" {...itemClasses('description') }>{lineItem.description}</Span>
        </td>
        <td />
        <td>{this.renderAmount(lineItem)}</td>
      </tr>
    );
  }

  renderAmount(lineItem: GQL.ILicenseLineItem | GQL.IGeneralLineItem) {
    const currencyProps: Partial<PriceTagOwnProps> = {
      currency: this.props.order.currency_code! as GQL.Currency,
      rate: this.props.order.currency_rate!,
    };
    return lineItem.discount_amount ? (
      <>
        <InvoicePriceTag
          strikeThrough
          amount={lineItem.amount!}
          size="small"
          {...currencyProps}
          {...itemClasses('amount') }
        />
        <InvoicePriceTag
          isDiscount
          amount={lineItem.amount! - lineItem.discount_amount}
          size="small"
          {...currencyProps}
          {...itemClasses('discount-amount') }
        />
      </>
    ) : (
      <InvoicePriceTag
        amount={lineItem.amount!}
        size="small"
        {...currencyProps}
        {...itemClasses('amount') }
      />
    );
  }

  render() {
    return (
      <table {...classes()}>
        <thead>
          <tr>
            <th><TableHeader label="Item" /></th>
            <th><TableHeader label="Description" /></th>
            <th><TableHeader label="Amount" /></th>
          </tr>
        </thead>
        <tbody>
          {this.props.order.license_line_items!.map(this.renderLicenseLineItem)}
          {this.props.order.general_line_items!.map(this.renderGeneralLineItem)}
        </tbody>
      </table>
    );
  }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/public/components/organisms/account/Invoice/InvoiceLineItems.tsx